import CustomTireSizeButton from "component/design-system/buttons/CustomTireSizeButton";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { isArray } from "../../../util/helper/isArray";

function TireSizeSummary(props: any) {
  const { currentSizes } = props;
  const { t } = useTranslation("category");
  const router = useRouter();
  const { query } = router;
  const { sizes } = query;
  if (!sizes) {
    return null;
  }

  return (
    <>

      <div className="p-t-10">

        <div className="d-flex" data-testid="tire-size-summary">

          <Text size={4} type={TEXT_TYPE.secondary} className="p-r-10 p-t-5">{`${t("Tire Size")}(s):`}</Text>

          <div className="d-flex flex-column">

            {isArray(sizes) && sizes.map((size: any) => (
              <Text key={size} bold className="m-t-10">
                {`${size.substr(-2)}" ${size.replace("-", "/")}`}
              </Text>
            ))}

            {!isArray(sizes) && (
              <Text bold className="m-t-10">

                {`${sizes.substr(-2)}" ${sizes.replace("-", "/")}`}
              </Text>
            )}
          </div>
        </div>

        <CustomTireSizeButton title={t("Select Tire Size")} currentSizes={currentSizes} style={{ width: "-webkit-fill-available", "font-size": "calc(1.8 * var(--safari-root-font, 10px))" }} />
      </div>
    </>
  );
}

export default TireSizeSummary;
